import _ from "@lodash";
import { Card, Radio, Tooltip, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import * as Helpers from "app/Core/Helpers";
import AgendamentoEdicaoApp from "app/CRM/AgendamentoEdicao/AgendamentoEdicaoApp";
import clsx from "clsx";
import { useSelector } from "react-redux";
import React from "react";
import { makeStyles } from "@material-ui/styles";

const styles = theme => ({
    borderColor: {
        borderColor: theme.palette.divider
    },
});

const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
});

function OportunidadeCard(props) {
    const tags = useSelector(({ Agendamento }) => {
        if (!_.isUndefined(Agendamento)) {
            return Agendamento.TagFuncionalidadeReducer["agendamento"];
        }
    });

    const { card, idagendamento, classes, setParent } = props;

    if (!card) {
        return null;
    }

    function getValorOportunidade(card) {
        if (card.preatendimento.pedido) {
            return _.sum(card.preatendimento.pedido.map(x => {
                if (!_.isNull(Number.parseFloat(x.valor)) && !_.isNaN(Number.parseFloat(x.valor))) {
                    return (Number.parseFloat(x.valor));
                }
                return 0;
            }));
        }
        return 0;
    }

    function getDiferencaHoje(card) {
        let ADIferenca = Helpers.DateDiffDays(card.inicio, new Date());
        if (new Date(card.inicio) > new Date()) {
            return "";
        }
        else if (ADIferenca === 0)
            return " hoje ";
        else if (ADIferenca === 1)
            return ADIferenca + " dia";
        else
            return ADIferenca + " dias";

    }

    return (
        <Card
            className={clsx("w-full mb-16 rounded-4 relative")}
            id={"card_" + card.idagendamento}
        >
            {/* <AgendamentoEdicaoApp
                xappRouteParams={props.xappRouteParams}
                callback={() => props.listFilter()}
                view={"Oportunidade"}
                isDialog={true}
                key={"Agendamento_Editar_Oportunidade"}
                tipo={4}
                idagendamento={card.idagendamento}
            >
                <XAPPButton
                    type="icon"
                    color=""
                    className={"absolute right-0"}
                    onClick={() => { }}
                    icon={"edit"}
                    iconProps={"text-20"}
                />
            </AgendamentoEdicaoApp> */}
            <>
                <div className="flex w-full">
                    <Radio
                        name="selected"
                        checked={card.idparent === idagendamento}
                        onClick={ev => ev.stopPropagation()}
                        onChange={ev => setParent(card.idagendamento)}
                    />
                    <div className="p-12 w-full">
                        {card.agendamentotag && card.agendamentotag.length > 0 && (
                            <div className="flex flex-wrap">
                                {!_.isUndefined(tags) && !_.isNull(tags) && tags.map(item => {
                                    if (card.agendamentotag.includes(item.codigo)) {
                                        return (
                                            <Tooltip title={item.tagnome} key={item.codigo}>
                                                <div className={clsx("w-32  h-6 rounded-6 mr-6 mb-6")} style={{ backgroundColor: item.cor }} />
                                            </Tooltip>
                                        );
                                    }
                                })}
                            </div>
                        )}
                        <Typography className="text-11 mb-8">{"Origem: " + card.origemdescricao}</Typography>
                        <div className="flex flex-col sm:flex-row">
                            <Typography className="font-600 mb-6 w-320 items-center">{Helpers.StringDateUSToBR(card.inicio).substring(0, 10) + " - " + getDiferencaHoje(card)}</Typography>
                            <Typography className="font-600 mb-6 w-320 items-center">{formatter.format(getValorOportunidade(card))}</Typography>
                            {card.preatendimento.pedido &&
                                <Typography className="font-600 mb-4 w-full items-center">{card.preatendimento.pedido.map((item, index) => (item.nome + (card.preatendimento.pedido.length > index + 1 ? ", " : "")))}</Typography>
                            }
                        </div>
                    </div>
                </div>
                {!_.isNull(card.cliente.observacao) && card.cliente.observacao.trim() !== "" &&
                    <div className={clsx(classes.borderColor, "flex w-full justify-between min-h-32 px-20 border-t-1")}>
                        <Typography className="font-600 flex items-center">{card.cliente.observacao}</Typography>
                    </div>
                }
            </>
        </Card>
    );
}

export default withStyles(styles, { withTheme: true })(OportunidadeCard);
